import { BlueprintInstanceType } from '../shared.enums';
import { Breakpoint } from './breakpoint.class';
import { deleteRuleManagedCfn } from './functions';
import { Publish } from '../../decorators';

import { BreakpointsDataIn, BreakpointsDataOut } from './types';
import { KitchenDesignBase, KitchenDesignOptions } from '../kitchen-design-base';
import { deleteItemByIdCfn } from '../shared.functions';

export class Breakpoints extends KitchenDesignBase<BreakpointsDataIn> {
	readonly children: Array<Breakpoint>;

	constructor (options: KitchenDesignOptions<BreakpointsDataIn> = {}) {
		super(BlueprintInstanceType.Breakpoints, options);

		this.children = [];
		if (options.dataIn && options.dataIn?.children && options.dataIn.children.length > 0) {
			options.dataIn.children.forEach((n) => this.children.push(new Breakpoint({ dataIn: n, parent: this })));
		}

		this.setInitialized();
	}

	/**
	 * Creates and adds a new breakpoint to the breakpoints instance
	 * @param islandType IslandsType enum
	 * @param center how far from the left edge is the center of the breakpoint
	 * @returns Instance of brekapoint created
	 */
	@Publish('breakpoint', 'created')
	public new (center: number): Breakpoint {
		const breakpoint = new Breakpoint({ dataIn: { center }, parent: this });
		this.children.push(breakpoint);

		return breakpoint;
	}

	/**
	 * removes breakpoint matching the provided id from breakpoints
	 * @param id id of breakpoint to delete
	 * @returns boolean: true if remove, false if error, null when not found
	 */
	// @Publish('breakpoint')
	public delete (id: string): boolean {
		if (deleteItemByIdCfn(this.children, id)) {
			this.context.cache.delete(id);
			return true;
		}
		return false;
	}

	/**
	 * Removes every rule-generated breakpoint, leaving hand-placed ones alone
	 * @returns number of breakpoints removed
	 */
	public deleteRuleManaged (): number { return deleteRuleManagedCfn(this as Breakpoints); }

	public serialize ():BreakpointsDataOut {
		return {
			children: this.children.map((breakpoint: Breakpoint) => breakpoint.serialize())
		};
	}
}
